/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse
     */
    orderRequestEncryptedTransactionId?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderRequestEncryptedTransactionId': !exists(json, 'OrderRequest_EncryptedTransactionId') ? undefined : json['OrderRequest_EncryptedTransactionId'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmSelectPayPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OrderRequest_EncryptedTransactionId': value.orderRequestEncryptedTransactionId,
    };
}

